/** Slow, bounded drift outside the temple's 3.85 m platform; no frame-rate-dependent motion. */
export function templeMistPosition(index: number, seconds: number) {
  const angle = (index * Math.PI) / 4 + seconds * 0.002;
  const radius = 18 + (index % 3) * 4;
  return {
    x: Math.cos(angle) * radius,
    y: -1.5 + (index % 3) * 1.8 + Math.sin(seconds * 0.015 + index) * 0.45,
    z: Math.sin(angle) * radius - 0.7,
  };
}
